import styled from 'styled-components';
export const CoverImage = styled.img `
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    position: fixed;
    object-fit: cover;
`;
export const CoverImageSource = styled.source `
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    position: fixed;
    object-fit: cover;
`;
export const ImageContainer = styled.div `
    width: 100%;
    height: 100vh;
    position: relative;
`;
//# sourceMappingURL=BackgroundImageContainer.Styled.js.map